class LocationSearchPlaceholderControl {
  constructor(options = {}) {
    this.container = null;
    this.options = options;
  }

  onAdd() {
    this.container = document.createElement('div');
    this.container.className = 'maplibregl-ctrl maplibregl-ctrl-group maplibregl-ctrl-location-search-placeholder';
    return this.container;
  }

  onRemove() {
    if (this.container?.parentNode) {
      this.container.parentNode.removeChild(this.container);
    }

    this.container = null;
  }
}

export default LocationSearchPlaceholderControl;
